import Vue from 'vue'
import { Component, Watch, Prop } from 'vue-property-decorator'
import UserNode from './UserNode.vue'

@Component({
  name: 'DeptNode',
  components: {
    UserNode,
  },
})
export default class DeptNode extends Vue {
  //
  // ──────────────────────────────────────────────────────── I ──────────
  //   :::::: P R O P S : :  :   :    :     :        :          :
  // ──────────────────────────────────────────────────────────────────
  //

  @Prop({ type: Object }) item!: DepartmentEx

  //
  // ──────────────────────────────────────────────────────── I ──────────
  //   :::::: M E T H O D : :  :   :    :     :        :          :
  // ──────────────────────────────────────────────────────────────────
  //

  toggle() {
    this.$emit('toggle', this.item)
  }
}
